import { render, staticRenderFns } from "./OptInModal.vue?vue&type=template&id=cb60da82&scoped=true"
import script from "./OptInModal.vue?vue&type=script&lang=js"
export * from "./OptInModal.vue?vue&type=script&lang=js"
import style0 from "./OptInModal.vue?vue&type=style&index=0&id=cb60da82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb60da82",
  null
  
)

export default component.exports